import { useState } from 'react'

import { useClipboard } from 'use-clipboard-copy'

import { T } from '@tribeplatform/react-components/i18n'
import { Input } from '@tribeplatform/react-ui-kit/Input'
import { Link } from '@tribeplatform/react-ui-kit/Link'

export const ShareInviteMemberLink = ({ url }) => {
  const [copied, setCopied] = useState(false)
  const clipboard = useClipboard()

  return (
    <>
      <div className="text-content">
        <T defaultMessage="Share invite link" id="UserImport.ShareLink" />
      </div>
      <div className="text-sm mb-2 text-content-subdued">
        <T
          defaultMessage="Anyone with this link can join as a member."
          id="UserImport.ShareLink.Description"
        />
      </div>
      <Input
        onClick={e => e.currentTarget.select()}
        value={url}
        readOnly
        trailingAddon={
          <Link
            onClick={() => {
              clipboard.copy(url)
              setCopied(true)
              setTimeout(() => setCopied(false), 2000)
            }}
            variant="neutral"
          >
            <T
              id="Generics.CopyTooltip"
              defaultMessage="{copied, select, true {Copied} other {Copy}}"
              values={{ copied }}
            />
          </Link>
        }
      />
    </>
  )
}
